/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HelpTicketCompetitionContext
 */
export interface HelpTicketCompetitionContext {
    /**
     * 
     * @type {string}
     * @memberof HelpTicketCompetitionContext
     */
    competitionId: string;
    /**
     * 
     * @type {string}
     * @memberof HelpTicketCompetitionContext
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof HelpTicketCompetitionContext
     */
    atRiskPausedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof HelpTicketCompetitionContext
     */
    atRiskReason?: string;
    /**
     * 
     * @type {string}
     * @memberof HelpTicketCompetitionContext
     */
    scoringGameId?: string;
}

/**
 * Check if a given object implements the HelpTicketCompetitionContext interface.
 */
export function instanceOfHelpTicketCompetitionContext(value: object): value is HelpTicketCompetitionContext {
    if (!('competitionId' in value) || value['competitionId'] === undefined) return false;
    return true;
}

export function HelpTicketCompetitionContextFromJSON(json: any): HelpTicketCompetitionContext {
    return HelpTicketCompetitionContextFromJSONTyped(json, false);
}

export function HelpTicketCompetitionContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): HelpTicketCompetitionContext {
    if (json == null) {
        return json;
    }
    return {
        
        'competitionId': json['competitionId'],
        'name': json['name'] == null ? undefined : json['name'],
        'atRiskPausedAt': json['atRiskPausedAt'] == null ? undefined : json['atRiskPausedAt'],
        'atRiskReason': json['atRiskReason'] == null ? undefined : json['atRiskReason'],
        'scoringGameId': json['scoringGameId'] == null ? undefined : json['scoringGameId'],
    };
}

export function HelpTicketCompetitionContextToJSON(json: any): HelpTicketCompetitionContext {
    return HelpTicketCompetitionContextToJSONTyped(json, false);
}

export function HelpTicketCompetitionContextToJSONTyped(value?: HelpTicketCompetitionContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competitionId': value['competitionId'],
        'name': value['name'],
        'atRiskPausedAt': value['atRiskPausedAt'],
        'atRiskReason': value['atRiskReason'],
        'scoringGameId': value['scoringGameId'],
    };
}

